import { MONTH_SEARCH_PARAM, YEAR_SEARCH_PARAM } from '../../../shared/config/index.js';

export const ROUTE = {
  attention: '/',
  payments: '/payments',
  paymentCreate: '/payments/new',
  paymentDetail: '/payments/:id',
  paymentEdit: '/payments/:id/edit',
  occurrencePay: '/occurrences/:id/pay',
  summary: '/summary',
  summaryCategory: '/summary/categories/:category',
  summaryMerchant: '/summary/categories/:category/merchant',
  operationDetail: '/summary/operations/:id',
  calendar: '/calendar',
  references: '/references',
} as const;

export const MERCHANT_SEARCH_PARAM = 'merchant';

type SummaryPeriod = {
  year: number | null;
  month: number | null;
};

export const paymentDetailPath = (id: string): string => `/payments/${id}`;

export const paymentEditPath = (id: string): string => `/payments/${id}/edit`;

export const occurrencePayPath = (id: string): string => `/occurrences/${id}/pay`;

export const periodSearchParamsOf = (period: SummaryPeriod): URLSearchParams => {
  const params = new URLSearchParams();

  if (period.year !== null) {
    params.set(YEAR_SEARCH_PARAM, String(period.year));
  }

  if (period.month !== null) {
    params.set(MONTH_SEARCH_PARAM, String(period.month));
  }

  return params;
};

const withSearch = (path: string, params: URLSearchParams): string => {
  const search = params.toString();

  return search === '' ? path : `${path}?${search}`;
};

export const summaryCategoryPath = (category: string, period: SummaryPeriod): string =>
  withSearch(`/summary/categories/${category}`, periodSearchParamsOf(period));

export const summaryMerchantPath = (
  category: string,
  merchantKey: string,
  period: SummaryPeriod,
): string =>
  withSearch(
    `/summary/categories/${category}/merchant`,
    new URLSearchParams([
      [MERCHANT_SEARCH_PARAM, merchantKey],
      ...periodSearchParamsOf(period).entries(),
    ]),
  );

export const operationDetailPath = (id: string): string => `/summary/operations/${id}`;
